import dynamic from 'next/dynamic';
import { RateDetailsProps } from './RateDetailsModal.types';

export const RateDetailsModalMGP = dynamic<RateDetailsProps>(() =>
  import('./RateDetailsModal').then(module => module.RateDetailsModal)
);
